import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { SwapParams, SwapInstructionsResponse } from "@loopscale/pandora-types";

import { pandoraBaseQuery } from "./util";
import { ROUTE_GET_SWAP_INSTRUCTIONS, ROUTE_GET_SWAP_ROUTES, ROUTE_GET_ASYNC_SWAP_STATUS } from "../constants";
import {
    AsyncSwapStatusResponse,
    AsyncSwapStatusParams,
    parseSwapRoutesResponseFromApi,
    SwapRoutesResponse,
    SwapRoutesResponseApi,
    SwapRoutesParams
} from "../types";

const LOOP_IXS_TAG = "LOOP_IXS_TAG";

export const loopIxsApi = createApi({
    reducerPath: "loopIxsApi",
    tagTypes: [LOOP_IXS_TAG],
    baseQuery: pandoraBaseQuery,
    endpoints: (builder) => ({
        swapInstructions: builder.query<SwapInstructionsResponse, SwapParams>({
            providesTags: [LOOP_IXS_TAG],
            query: (params) => ({
                url: ROUTE_GET_SWAP_INSTRUCTIONS,
                method: "POST",
                body: params
            })
        }),
        swapRoutes: builder.query<SwapRoutesResponse, SwapRoutesParams>({
            query: (params) => ({
                url: ROUTE_GET_SWAP_ROUTES,
                method: "GET",
                params
            }),
            transformResponse: (response: SwapRoutesResponseApi): SwapRoutesResponse =>
                parseSwapRoutesResponseFromApi(response)
        }),
        asyncSwapStatus: builder.query<AsyncSwapStatusResponse, AsyncSwapStatusParams>({
            query: ({ redemptionId, routeType, state }) => ({
                url: `${ROUTE_GET_ASYNC_SWAP_STATUS}/${encodeURIComponent(redemptionId)}`,
                method: "GET",
                params: state ? { routeType, state } : { routeType }
            })
        })
    })
});

export const { useSwapInstructionsQuery, useSwapRoutesQuery, useAsyncSwapStatusQuery } = loopIxsApi;

export function useLoopIxsApi() {
    const dispatch = useDispatch();
    return {
        resetLoopIxsApi: () => dispatch(loopIxsApi.util.invalidateTags([LOOP_IXS_TAG]))
    };
}
